import styled from 'styled-components';
import { colors } from 'globalStyles';

export const Wrapper = styled.div`
  width: 300px;
  padding-top: 34px;
  color: ${colors.BODY};
`;

export const Text = styled.div`
  font-size: 16px;
  line-height: 24px;
  > a {
    text-decoration: underline;
  }
`;



// WEBPACK FOOTER //
// ./src/components/LapsedModal/styledComponents.js